import styled from 'styled-components';

export const Container = styled.div`
  .stars {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.2rem;
  }
`;
